import { render, staticRenderFns } from "./MissingRevenues.vue?vue&type=template&id=507cf09e&"
import script from "./MissingRevenues.vue?vue&type=script&lang=js&"
export * from "./MissingRevenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports